module.exports = __webpack_public_path__ + "img/00_mogu.134a77b8.png";